<template>
  <md-button v-bind="$attrs" class="md-dense file-button-hidden">
    <slot/>
    <input type="file" class="" @change="onChange" :accept="$attrs.accept">
  </md-button>
</template>

<script>
export default {
  name: "FileButton",
  props: { },
  methods: {
    onChange($event) {
      this.$emit('change', $event)
    }
  }
}
</script>

<style>
.file-button-hidden {
  position: relative;
}
.file-button-hidden .md-button-content {
  position: unset;
}
.file-button-hidden input[type=file] {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  opacity: 0;
}
</style>